import React from 'react';
import styled from 'styled-components';

import FlexContainer from 'components/lib/ui/FlexContainer';
import NestedDropdownSubMenu from 'components/lib/ui/NestedDropdownSubMenu';
import Text from 'components/lib/ui/Text';

import featureList from 'lib/features/featureList';
import { useFeatureFlagsWithStatus } from 'lib/hooks/useFeatureFlag';

export const EmployeeMenuFeatureFlags = () => {
  // @ts-expect-error - featureList is a readonly array
  const { flags } = useFeatureFlagsWithStatus(featureList);

  return (
    <NestedDropdownSubMenu title="Enabled Feature Flags">
      {/* eslint-disable-next-line fp/no-mutating-methods */}
      {Object.entries(flags)
        .sort(([a], [b]) => a.localeCompare(b))
        .filter(([_, { treatment }]) => treatment === 'on')
        .map(([flag, { treatment }]) => (
          <Row key={flag}>
            <Text>{flag}</Text>
            <Text>{treatment}</Text>
          </Row>
        ))}
    </NestedDropdownSubMenu>
  );
};

const Row = styled(FlexContainer).attrs({ justifyBetween: true })`
  padding: 2px ${({ theme }) => theme.spacing.large};
  font-size: ${({ theme }) => theme.fontSize.xsmall};
  font-family: monospace;

  &:nth-child(even) {
    background-color: ${({ theme }) => theme.color.gray2};
  }
`;
